// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"solarspeicher_productcontent__Sc9oN"};